import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VisitorStatisticExportComponent } from './component/visitor-statistic-export.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { ApplicationClientCommonModule, CommonTranslationModule, DictionaryModule } from '@sdbn/common';

@NgModule({
  imports: [
    CommonModule,
    DictionaryModule,
    MatTableModule,
    MatSortModule,
    ReactiveFormsModule,
    FormsModule,
    ApplicationClientCommonModule,
    CommonTranslationModule
  ],
  declarations: [VisitorStatisticExportComponent]
})
export class VisitorStatisticExportModule { }
